var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['q-datepicker', _vm.variation]},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date),expression:"date"}],ref:"input",staticClass:"input",attrs:{"type":"date"},domProps:{"value":(_vm.date)},on:{"input":[function($event){if($event.target.composing)return;_vm.date=$event.target.value},_vm.input]}})])
}
var staticRenderFns = []

export { render, staticRenderFns }